export const rad = (x) => {
  return x * Math.PI / 180
}

export const haversineDistance = (p1, p2) => {
  const R = 6371
  const dLat = rad(p2.latitude - p1.latitude)
  const dLong = rad(p2.longitude - p1.longitude)
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(p1.latitude)) * Math.cos(rad(p2.latitude)) * Math.sin(dLong / 2) * Math.sin(dLong / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c
  return d * 1000
}

export const parseDistance = (distance) => {
  if (distance >= 1000) {
    return `${Math.round(distance / 1000, 0)} km`
  } else {
    return `${Math.round(distance, 0)} m`
  }
}
